import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constant } from '../common/constant';
import { Observable } from 'rxjs';
import { EmployeeAddModel } from '../models/employee.model';
import { BookedGuestRegisterModel } from '../models/bookedGuest.model';

@Injectable()
export class EmployeeService {

    constructor(private readonly http: HttpClient) {
    }

    registerEmployee(details): Observable<EmployeeAddModel> {
        const url = Constant.REST_URL + Constant.EMPLOYEE + Constant.REGISTER_EMPLOYEE;
        return this.http.post<EmployeeAddModel>(url , details);
    }

    getAllEmployee(params , accountId, search) {
        const url = Constant.REST_URL + Constant.EMPLOYEE + Constant.GET_ALL_EMPLOYEE
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + search
        + '&accountId=' + accountId;
        return this.http.get(url);
    }

    // forEdit: the edit form needs the real values even when the property hides sensitive data.
    getEmployeeDataById(id, forEdit = false)  {
        const url = Constant.REST_URL + Constant.EMPLOYEE + Constant.GET_EMPLOYEE_BY_ID + '?employeeId=' + id + (forEdit ? '&forEdit=true' : '');
        return this.http.get(url);
    }

    registerBookedVisitorByEmployee(details): Observable<BookedGuestRegisterModel> {
        const url = Constant.REST_URL + Constant.GUEST + Constant.REGISTER_COMMERCIAL_GUEST;
        return this.http.post<BookedGuestRegisterModel>(url , details);
    }

    getAllBookedGuestListByResidentId(params, searchBy, accountId , employeeId , type, status?: string) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_ALL_EMPLOYEE_GUEST
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy +
        '&accountId=' + accountId + '&employeeId=' + employeeId + '&type=' + type + (status ? '&status=' + status : '');
        return this.http.get(url);
    }

    getAllStaffListByAccountId(params, searchBy, accountId , type, mode) {
        const url = Constant.REST_URL + Constant.EMPLOYEE + Constant.GET_STAFF_CHECK_IN
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy +
        '&accountId=' + accountId + '&type=' + type + '&mode=' + mode;
        return this.http.get(url);
    }

    importEmployee(formData, accountId) {
        const url = Constant.REST_URL + Constant.EMPLOYEE + Constant.IMPORT_EMPLOYEE + '?accountId=' + accountId;
        return this.http.post(url, formData);
    }

    getRecallGuestById(guestId, forEdit = false) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_RECALL_GUEST_BY_ID
        + '?guestId=' + guestId + (forEdit ? '&forEdit=true' : '');
        return this.http.get(url);
    }

    getStaffQRImage(id)  {
        const url = Constant.REST_URL + Constant.EMPLOYEE + Constant.GET_STAFF_QR_IMAGE + '?staffId=' + id;
        return this.http.get(url);
    }

    regenerateQRCode(staffId) {
        const url = Constant.REST_URL + Constant.EMPLOYEE + Constant.REGENERATE_STAFF_QRCODE +
         '?staffId=' + staffId;
        return this.http.get(url);
    }

    checkStaffQRExpire(staffId, accountId) {
        const url = Constant.REST_URL + Constant.EMPLOYEE + Constant.CHECK_STAFF_QR_EXPIRE +
         '?staffId=' + staffId + '&accountId=' + accountId;
        return this.http.get(url);
    }

    getAllEmployeeList(id)  {
        const url = Constant.REST_URL + Constant.EMPLOYEE + Constant.GET_STAFF_LIST + '?accountId=' + id;
        return this.http.get(url);
    }

    getAllStaffByAccountId(params, searchBy, accountId , type) {
        const url = Constant.REST_URL + Constant.EMPLOYEE + Constant.GET_ALL_STAFF
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy +
        '&accountId=' + accountId + '&type=' + type;
        return this.http.get(url);
    }

    checkInEmployee(details) {
        const url = Constant.REST_URL + Constant.EMPLOYEE + Constant.CHECK_IN_CHECK_OUT;
        return this.http.post(url , details);
    }
}
